import isEmpty from "lodash/isEmpty";
import { generateUID } from "@/utils.js";

export default {
    getSelectedActivities: (state, _getters, rootState) => {
        let activity = rootState.forms.VotreProject.Sectors.find(
            element => state.project.activity == element.value
        );

        return activity;
    },

    getEntreprise: (_state, _getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.entreprise_info)
        ) {
            const entreprisesProfiles = rootState.user.bpi.entreprise_info;

            return {
                ...entreprisesProfiles
            };
        }

        const partners = [];
        rootState.ProfilsDesInvestisseurs.investors.forEach(investor => {
            partners.push({
                name: `${investor.lastName} ${investor.firstName}`,
                percentage: 100,
                isManager: false,
                key: generateUID()
            });
        });
        partners.forEach(elem => {
            elem.percentage = Math.floor(100 / partners.length);
        });

        let total = partners.reduce((a, b) => {
            return a + b.percentage;
        }, 0);

        if (total !== 100) {
            let rest = 100 - total;
            partners[partners.length - 1].percentage += rest;
        }

        return {
            isCreated: "",
            name: "",
            legalForm: null,
            creationDate: "",
            Address: "",
            capitalSocial: null,
            partners: [...partners]
        };
    },

    getProject: (_state, _getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.project_info)
        ) {
            const projectsProfiles = rootState.user.bpi.project_info;

            return {
                ...projectsProfiles
            };
        }

        return {
            title: "",
            description: "",
            startDate: "",
            isStarted: null,
            sector: null,
            branch: null,
            subBranch: null,
            activity: null
        };
    },

    getOffers: (_state, _getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.offers.length !== 0
        ) {
            const offersProfiles = rootState.user.bpi.offers;

            const offers = offersProfiles.map(offer => {
                return {
                    model: "product-card",
                    key: generateUID(),
                    object: {
                        ...offer
                    }
                };
            });

            return offers;
        }

        return [
            {
                model: "product-card",
                key: generateUID(),
                object: {
                    id: generateUID(),
                    name: "",
                    description: "",
                    type: "product"
                }
            }
        ];
    },

    getClients: (_state, _getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.clients_info.length !== 0
        ) {
            const clientsProfiles = rootState.user.bpi.clients_info;

            const clients = clientsProfiles.map(client => {
                return {
                    model: "client-card",
                    key: generateUID(),
                    object: {
                        ...client
                    }
                };
            });
            return clients;
        }

        return [
            {
                model: "client-card",
                key: generateUID(),
                object: {
                    id: generateUID(),
                    name: "",
                    type: "client",
                    clientOrigin: "",
                    caPercentage: null,
                    paymentDeadline: null,
                    paymentType: []
                }
            }
        ];
    }
};
